// src/components/common/Header.jsx
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";
import Button from "./common/Button";
import { useMediaQuery } from "react-responsive";
import { getScrollRefByKey, scrollToRef } from "../backend/scrollToRef";
import { getMainInfoByName } from "../backend/info/mainInfo";
import { getWeekendInfoByName } from "../backend/weekends/weekendInfo";
import "./Header/Header.scss";


const Header = ({
                  onChangeMenu = (value) => {
                  }, isMenuOpen_base = false
                }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(isMenuOpen_base);
  const [isHoveringSupport, setIsHoveringSupport] = useState(false);
  const [dropdownPos, setDropdownPos] = useState(null);

  const supportRef = useRef(null);

  useEffect(() => {
    setIsMenuOpen(isMenuOpen_base);
  }, [isMenuOpen_base]);

  const navigate = useNavigate();

  const isMobile = useMediaQuery({query: `(max-width: 810px)`});
  const isSmall = useMediaQuery({query: `(max-width: 550px)`});
  const showFourButtons = useMediaQuery({query: `(min-width: 1500px)`});
  const showThreeButtons = useMediaQuery({query: `(min-width: 1300px)`});
  const showTwoButtons = useMediaQuery({query: `(min-width: 900px)`});

  useEffect(() => {
    document.body.style.overflow = isMenuOpen && isMobile ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isMenuOpen]);

  // Update dropdown position on scroll so it stays anchored
  useEffect(() => {
    const handleScroll = () => {
      if (supportRef.current) {
        const rect = supportRef.current.getBoundingClientRect();
        setDropdownPos({
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const location = useLocation();

  const buttonSize = {
    padding: isMobile ? "0.5rem 0rem" : "0.75rem 0rem",
    fontSize: isMobile ? "min(3.5vw, 1.25rem)" : "1.25rem",
  };

  return (
    <>
      <header style={styles.headerContainer}>
        <nav style={styles.navContainer}>
          {isMenuOpen && isMobile ? (
            <div
              style={{...styles.leftSide, gap: isMobile ? "3vw" : "1rem", cursor: "pointer"}}
              onClick={() => {
                setIsMenuOpen(false);
                onChangeMenu(false);
                navigate("/");
              }}
            >
              <img
                src="/assets/icons/210-logo-big-bw.svg"
                alt="Логотип"
                style={{...styles.icon, left: 0}}
              />

              <p style={styles.logoText}>
                210
                <br/>
                Окремий
                <br/>
                Штурмовий
                <br/>
                Полк
              </p>
            </div>
          ) : !isMobile ? (
            <div style={styles.leftSide}>
              <a
                href="/"
                onClick={() => {
                  setIsMenuOpen(false);
                  onChangeMenu(false);
                }}
              >
                <img src="/assets/icons/210-logo-big-bw.svg" alt="logo" style={styles.icon}/>
              </a>
              <div style={styles.leftButtonRow} onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                onChangeMenu(!isMenuOpen);
              }}>
                <Button
                  text={isMenuOpen ? "ЗАКРИТИ" : "МЕНЮ"}
                  textColor="var(--white)"
                  hoverTextColor="var(--orange)"
                  fontFamily="UAFSans-Book"
                  padding="0rem"
                  className="header__hamburger-btn"
                />
                {isMobile && isMenuOpen && (
                  <img
                    src="/assets/icons/close.svg"
                    style={{width: "2rem", height: "2rem"}}
                    alt="закрити"
                  />
                )}
              </div>
              {!location.pathname.startsWith("/vyshkil-nrk") &&
                !location.pathname.startsWith("/test-weekend") &&
                showTwoButtons && (
                  <Button
                    text={getMainInfoByName("headerButtonName") ?? "МЕРЧ"}
                    onClick={
                      (getMainInfoByName("headerButtonLink") ?? "/shop").startsWith("/")
                        ? () => navigate(getMainInfoByName("headerButtonLink") ?? "/shop")
                        : undefined
                    }
                    external_link={
                      !(getMainInfoByName("headerButtonLink") ?? "/shop").startsWith("/")
                        ? getMainInfoByName("headerButtonLink")
                        : undefined
                    }
                    textColor="var(--orange)"
                    hoverTextColor="var(--black)"
                    border="2px solid var(--orange)"
                    hoverBackgroundColor="var(--orange)"
                    fontFamily="UAFSans-Book"
                    padding={"0.75rem 2rem"}
                    fontSize={buttonSize.fontSize}
                  />
                )}
            </div>
          ) : (
            <div
              style={styles.menuIconContainer}
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                onChangeMenu(!isMenuOpen);
              }}
            >
              <img src={"/assets/icons/menu.svg"} alt="меню" />
            </div>
          )}
          <a className="header" href="tel:+380982102101" target="_blank" style={styles.phoneNumber}>
            <span className="header__phone">(098) 210 210 1</span>
            <img className="header__phone-icon" src={"/assets/icons/phone.avif"} alt="Тел." />
          </a>
          {!(isMenuOpen && isMobile) ? (
            <div style={styles.rightSide}>
              {/* Підтримати with portal dropdown */}
              {!isSmall && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    zIndex: "1000000",
                  }}
                >
                  <div
                    ref={supportRef}
                    style={{
                      ...styles.supportButtonRow,
                      backgroundColor: isHoveringSupport ? "var(--white)" : "",
                      color: isHoveringSupport ? "var(--black)" : "var(--white)",
                      border: isHoveringSupport ? "none" : "2px solid var(--white)",
                      borderBottom: isHoveringSupport ? "2px solid var(--black)" : "2px solid var(--white)",
                      padding: buttonSize.padding,
                      fontSize: buttonSize.fontSize,
                      position: "relative",
                      zIndex: 1,
                    }}
                    onMouseEnter={() => {
                      setIsHoveringSupport(true);
                      const rect = supportRef.current.getBoundingClientRect();
                      setDropdownPos({
                        top: rect.top,
                        left: rect.left,
                        width: rect.width,
                        height: rect.height,
                      });
                    }}
                    onMouseLeave={() => setIsHoveringSupport(false)}
                  >
                    <p>ПІДТРИМАТИ</p>
                    <img
                      src={
                        isHoveringSupport
                          ? "/assets/icons/arrow-pag.svg"
                          : "/assets/icons/arrow-pag-white.svg"
                      }
                      style={{
                        width: "1.2rem",
                        transform: isHoveringSupport ? "rotate(90deg)" : "rotate(-90deg)",
                      }}
                    />
                  </div>
                </div>
              )}

              <Button
                text="ПРИЄДНАТИСЬ"
                external_link={getMainInfoByName("anketaLink")}
                textColor="var(--orange)"
                hoverTextColor="var(--black)"
                border="2px solid var(--orange)"
                hoverBackgroundColor="var(--orange)"
                fontFamily="UAFSans-Book"
                containerProps={{width: "min(12rem, 30vw)"}}
                padding={buttonSize.padding}
                fontSize={buttonSize.fontSize}
              />
            </div>
          ) : (
            <div
              style={styles.menuIconContainer}
              onClick={() => {
                setIsMenuOpen(!isMenuOpen);
                onChangeMenu(!isMenuOpen);
              }}
            >
              <img src="/assets/icons/close.svg" alt="закрити"/>
            </div>
          )}
        </nav>
      </header>

      {/* Portal dropdown — rendered directly into document.body, anchored via fixed positioning */}
      {isHoveringSupport &&
        dropdownPos &&
        createPortal(
          <div
            style={{
              position: "fixed",
              top: dropdownPos.top,
              left: dropdownPos.left,
              width: dropdownPos.width,
              display: "flex",
              flexDirection: "column",
              zIndex: 2000000,
            }}
            onMouseEnter={() => setIsHoveringSupport(true)}
            onMouseLeave={() => setIsHoveringSupport(false)}
          >
            {/* Button copy — sits at the top of the portal, visually identical to the real button */}
            <div
              style={{
                ...styles.supportButtonRow,
                backgroundColor: "var(--white)",
                color: "var(--black)",
                padding: buttonSize.padding,
                fontSize: buttonSize.fontSize,
                height: dropdownPos.height,
                boxSizing: "border-box",
                border: isHoveringSupport ? "none" : "2px solid var(--white)",
                borderBottom: isHoveringSupport ? "2px solid var(--black)" : "2px solid var(--white)",
                flexShrink: 0,
              }}
            >
              <p>ПІДТРИМАТИ</p>
              <img
                src="/assets/icons/arrow-pag.svg"
                style={{width: "1.2rem", transform: "rotate(90deg)"}}
              />
            </div>

            {/* Dropdown items */}
            <div
              style={{
                backgroundColor: "var(--olive)",
                padding: "0.75rem 0rem",
                display: "flex",
                flexDirection: "column",
                gap: "0.75rem",
                alignItems: "center",
                boxShadow: "10px 8px 24px rgba(0,0,0,0.2)",
              }}
            >
              <Button
                text="ТЕРМІНОВИЙ ЗБІР"
                textColor="var(--black)"
                hoverTextColor="var(--white)"
                fontFamily="UAFSans-Book"
                padding="0rem"
                fontSize="1.25rem"
                textAlign="center"
                external_link={getMainInfoByName("supportLink")}
              />
              <div
                style={{width: "calc(100% - 3rem)", height: "1.6px", backgroundColor: "black", margin: "0px 1.5rem"}}/>
              <Button
                text="ПІДПИСКА"
                textColor="var(--black)"
                hoverTextColor="var(--white)"
                fontFamily="UAFSans-Book"
                padding="0rem"
                fontSize="1.25rem"
                external_link={getMainInfoByName("subscriptionLink")}
              />
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

const styles: Record<string, React.CSSProperties> = {
  headerContainer: {
    backgroundColor: "var(--black)",
    backdropFilter: "blur(5px)",
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    maxWidth: "var(--main-container-width)",
    margin: "0 auto",
    height: "var(--header-height)",
  },
  leftSide: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  leftButtonRow: {
    display: "flex",
    flexDirection: "row",
    gap: "1.5rem",
    position: "relative",
    left: "-30px",
    cursor: "pointer",
    padding: "1rem 0rem",
  },
  icon: {
    height: "var(--header-height)",
    filter: "invert(1)",
    position: "relative",
    left: "-46.5px",
    cursor: "pointer",
  },
  rightSide: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
  },
  menuIconContainer: {
    width: "clamp(2rem, 7vw, 3rem)",
    height: "clamp(2rem, 7vw, 3rem)",
    cursor: "pointer",
  },
  logoText: {
    color: "var(--orange)",
    fontSize: "0.95rem",
    fontWeight: "bold",
  },
  supportButtonRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    minWidth: "250px",
    cursor: "pointer",
    color: "var(--white)",
    fontFamily: "UAFSans-Book",
    fontWeight: "normal",
    userSelect: "none",
    transition: "all 0.3s",
  },
};

export default Header;
